export default "__VITE_ASSET__CpZ63bE1__"